import { createContext } from 'react';

const SpinWinContext = createContext(null);

export default SpinWinContext;